import { Component, EventEmitter, Input, OnChanges, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { AbsiTemplateVersionResource } from '../../absi';
import { BaseComponent } from 'src/app/common/base/base.component';
import { WFSectionConfig } from 'src/app/components/workflow/workflow';
import { AbsiBuilderSectionComponent } from './absi-builder-section/absi-builder-section.component';

@Component({
  selector: 'absi-builder-main',
  templateUrl: './absi-builder-main.component.html',
  styleUrls: ['./absi-builder-main.component.scss']
})
export class AbsiBuilderMainComponent extends BaseComponent implements OnChanges {

  @Input() version?: AbsiTemplateVersionResource | null;

  @ViewChildren(AbsiBuilderSectionComponent)
  sectionComponents!: QueryList<AbsiBuilderSectionComponent>;

  sections?: WFSectionConfig[];
  wfTableId!: number;

  /**
   * Reads the hydrated workflow sections from the selected template version and
   * hides internal sections numbered 100+ from the builder UI.
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (this.version)
      this.wfTableId = this.version?.wfTableID ?? 0;
    this.sections = this.version?.wfTableConfig?.wfSectionConfigs?.filter(s => s.number && s.number < 100).sort((a, b) => a.number - b.number);
  }
}

